import { extract } from 'yafrpl/objects';

export default extract([
  // React attributes
  'className',
  'children',
  'dangerouslySetInnerHTML',
  'defaultChecked',
  'defaultValue',
  'htmlFor',
  /^on/,
  'ref',
]);
